import Icon from "@mui/icons-material/Settings";
import YearlyLedgerSettingsPage from "./YearlyLedgerSettingsPage";

export default {
  list: YearlyLedgerSettingsPage,
  icon: Icon,
  label: "Settings",
  options: { label: "Settings" },
  name: "yearlyLedgerSettings",
};
